import { render, staticRenderFns } from "./VueKaikas.vue?vue&type=template&id=0617ec36&scoped=true&"
import script from "./VueKaikas.vue?vue&type=script&lang=js&"
export * from "./VueKaikas.vue?vue&type=script&lang=js&"
import style0 from "./VueKaikas.vue?vue&type=style&index=0&id=0617ec36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0617ec36",
  null
  
)

export default component.exports